import { createReducer, on } from '@ngrx/store';
import { HolderState } from '@products/models/holder.model';
import { HolderActions } from '@store/products/holder/holder.actions';
import { ResetProductsActions } from '@store/products/product.actions';

export { HolderState as State };

export const initialState: HolderState = {
  ticketHolder: null,
  ticketHolderFormSubmitResult: null,
  inputs: [],
  questionnaireInputs: []
};

export const holderReducer = createReducer(
  initialState,
  on(HolderActions.setQuestionnaireInputs, (state, { questionnaireInputs }) => ({ ...state, questionnaireInputs })),
  on(HolderActions.setTicketHolder, (state, { ticketHolder }) => ({ ...state, ticketHolder })),
  on(HolderActions.setPostTicketHolderFormResult, (state, { ticketHolderFormSubmitResult }) => ({
    ...state,
    ticketHolderFormSubmitResult
  })),
  on(HolderActions.setTicketHolderInputs, (state, { inputs }) => ({ ...state, inputs })),
  on(HolderActions.resetReducer, () => initialState),
  on(ResetProductsActions.resetHolderReducer, () => initialState)
);
